import { ProductKind } from 'constants/product'

/**
 * Mirrors backend-platform `GuidelinesProductKindMapper` (ISSUE-1675).
 * Source of truth: Notion "Product" select values; backend file:
 * `platform/src/main/kotlin/co/.../service/guidelines/GuidelinesProductKindMapper.kt`.
 *
 * Used to reverse-lookup a ProductKind from the `productId` (Notion display name)
 * returned by `GET /guidelines`, so the list view can route clicks to
 * `GET /guidelines/{productKind}`. The user-facing button label is `item.title`;
 * this map is only used to resolve which endpoint to call.
 */
export const PRODUCT_KIND_TO_NOTION_DISPLAY_NAME: Partial<Record<ProductKind, string>> = {
  [ProductKind.GROUND_PHOTO]: 'Ground Photo',
  [ProductKind.DRONE_PHOTO]: 'Drone Photo',
  [ProductKind.MAST_PHOTO]: 'Mast Photo',
  [ProductKind.GROUND_PHOTO_PRESTIGE]: 'Prestige Photo',
  [ProductKind.EXTERIOR_SHOOT]: 'Exterior Photo',
  [ProductKind.MATTERPORT_PHOTO]: 'Matterport Photo',
  [ProductKind.PORTRAIT]: 'Portrait',
  [ProductKind.CORPORATE]: 'Corporate',
  [ProductKind.STANDARD_GROUND_VIDEO]: 'Ground Video',
  [ProductKind.STANDARD_DRONE_VIDEO]: 'Drone Video',
  [ProductKind.STANDARD_GROUND_AND_DRONE_VIDEO]: 'Ground & Drone Video',
  [ProductKind.PRESTIGE_GROUND_AND_DRONE_VIDEO]: 'Prestige Video',
  [ProductKind.REEL_VIDEO]: 'Reel Video',
  [ProductKind.TEASER_VIDEO]: 'Teaser Video',
  [ProductKind.SLIDESHOW]: 'Slideshow',
  [ProductKind.MATTERPORT_FLOOR_PLAN_WITH_VISIT]: 'Matterport Floor Plan (with visit)',
  [ProductKind.MATTERPORT_FLOOR_PLAN_WITHOUT_VISIT]: 'Matterport Floor Plan (without visit)',
  [ProductKind.FLOOR_PLAN_EDITING_2D]: 'Floor Plan 2D',
  [ProductKind.FLOOR_PLAN_EDITING_3D]: 'Floor Plan 3D',
  [ProductKind.MOBILE_APPLICATION_FLOOR_PLAN]: 'Mobile Floor Plan',
  [ProductKind.FLOOR_PLAN_RENDERING_3D]: 'Floor Plan Rendering 3D',
  [ProductKind.RESIDENTIAL_STAGING]: 'Residential Staging',
  [ProductKind.COMMERCIAL_STAGING]: 'Commercial Staging',
  [ProductKind.RESIDENTIAL_RENDERING]: 'Residential Rendering',
  [ProductKind.COMMERCIAL_RENDERING]: 'Commercial Rendering',
  [ProductKind.RESIDENTIAL_RENOVATION]: 'Residential Renovation',
  [ProductKind.COMMERCIAL_RENOVATION]: 'Commercial Renovation',
  [ProductKind.MEASUREMENT_ON_SITE]: 'Measurement on Site',
  [ProductKind.FLOOR_PLAN_CERTIFICATION]: 'Floor Plan Certification',
  [ProductKind.HD]: 'Virtual Visit - Matterport',
  [ProductKind.SD]: 'Virtual Visit - 360 Camera',
  [ProductKind.FLOORFY_VIRTUAL_TOUR]: 'Virtual Visit - Floorfy',
}

const NOTION_DISPLAY_NAME_TO_PRODUCT_KIND: Record<string, ProductKind> = Object.fromEntries(
  Object.entries(PRODUCT_KIND_TO_NOTION_DISPLAY_NAME).map(([kind, name]) => [name as string, kind as ProductKind])
)

export function productKindFromNotionDisplayName(displayName: string | null | undefined): ProductKind | undefined {
  if (!displayName) return undefined
  return NOTION_DISPLAY_NAME_TO_PRODUCT_KIND[displayName]
}
